import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import './Reports.css';

const REPORT_CARDS = [
  {
    perm: 'reports.customer-view',
    path: '/reports/weekly-delivery',
    icon: '📅',
    title: 'Weekly Delivery Summary',
    description: 'Distinct customers with PUB, PMB, and KIT deliveries across the next 4 weeks, with 4-week average.',
  },
  {
    perm: 'reports.itemrequirement.view',
    path: '/reports/item-requirements',
    icon: '📦',
    title: 'Item / Product Requirements',
    description: 'Required products, child products, and raw items for upcoming deliveries vs stock on hand.',
  },
  {
    perm: 'reports.customer-view',
    path: '/reports/customer-view',
    icon: '👥',
    title: 'Customer View',
    description: 'View customer orders, delivery history, and account details.',
  },
  {
    perm: 'reports.customer-view',
    path: '/reports/sales-report',
    icon: '📦',
    title: 'Sales Report',
    description: 'Product-wise sales with quantity, amount, and GST breakdown.',
  },
  {
    perm: 'reports.task-exceptions',
    path: '/reports/task-exceptions',
    icon: '⏱️',
    title: 'Task Exception Report',
    description: 'Flag employees with task logging gaps or insufficient working hours.',
  },
  {
    perm: 'reports.task-exceptions',
    path: '/reports/employee-tasks',
    icon: '📋',
    title: 'Employee Task Report',
    description: 'View all tasks logged by an employee for a selected date range.',
  },
];

const Reports = () => {
  const { user } = useContext(AuthContext);
  const hasPerm = (name) => user?.permissions?.some((p) => p.name === name) ?? false;

  const visible = REPORT_CARDS.filter((c) => hasPerm(c.perm));

  return (
    <div className="rp-page">
      <h2 className="rp-title">Reports</h2>
      <div className="rp-grid">
        {visible.map((card) => (
          <Link key={card.path} to={card.path} className="rp-card">
            <span className="rp-card-icon">{card.icon}</span>
            <div className="rp-card-body">
              <div className="rp-card-title">{card.title}</div>
              <div className="rp-card-desc">{card.description}</div>
            </div>
            <span className="rp-card-arrow">›</span>
          </Link>
        ))}
        {visible.length === 0 && (
          <p className="rp-empty">No reports available for your role.</p>
        )}
      </div>
    </div>
  );
};

export default Reports;
